<template>
	<h1>{{ $t('connect.disconnect') }}</h1>
</template>

<script>
	import store from "../store";

	export default {
		name: "logout",
		mounted: async function () {
			
			var name = "login";

			this.$store.commit("removeJwt");
			this.$store.commit("removeUser");
			this.$store.commit("removeClient");
			this.$router.push({ name: name });
		},
	};
</script>
